import { MessageCircle } from "lucide-react";

export const DownloadBar = () => {
  const shareWhatsApp = () => {
    const url = window.location.origin;
    const text = `You are cordially invited to the Gol Dhana & Engagement Ceremony of Nikhil Ahuja & Parita Jagad.\n\nSunday, 2nd August 2026, 6:00 PM onwards\nBliss Dine Restaurant & Banquet, Chandlodiya, Ahmedabad\n\nTap to open your invitation:\n${url}`;
    window.open(`https://wa.me/?text=${encodeURIComponent(text)}`, "_blank", "noopener");
  };

  return (
    <div className="download-bar">
      <button className="dl-btn green" onClick={shareWhatsApp} data-testid="share-whatsapp-btn">
        <MessageCircle size={16} /> Share on WhatsApp
      </button>
    </div>
  );
};
